import { render, staticRenderFns } from "./OutfitsFilter.vue?vue&type=template&id=5c3cd0bb&scoped=true&"
import script from "./OutfitsFilter.vue?vue&type=script&lang=js&"
export * from "./OutfitsFilter.vue?vue&type=script&lang=js&"
import style0 from "./OutfitsFilter.vue?vue&type=style&index=0&id=5c3cd0bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3cd0bb",
  null
  
)

export default component.exports